import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import lodashGet from 'lodash.get';
import { ExternalLinksDictionary } from 'connected-components/dictionaries/external-links';
import { IDENTITY_CUSTOMER_TYPES } from 'connected-components/constants/user';
import { REDIRECT_TO_MY_ACCOUNT } from '../../constants/identityConstants';
import Spinner from '@ow/ow-components/lib/components/Spinner';
import styled from 'styled-components';
import { getCookie } from 'connected-components/utils/CookieUtils';
import { FORCE_FRA_CATALOGUE } from '../../../config/global.config';
import { cleanUrl } from '../../utils/securityUtils';
import { FEATURES } from '../../constants/featureConstants';

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
`;

class LoginRedirect extends Component {
  componentDidMount() {
    this.handleRedirect();
  }

  componentDidUpdate() {
    this.handleRedirect();
  }

  handleRedirect() {
    if (this.props.isLoggedIn && this.shouldRedirect()) {
      const redirectUrl = cleanUrl(this.getRedirectPath());
      window.location.replace(redirectUrl);
    }
  }

  shouldRedirect = () => {
    return (
      getCookie(FORCE_FRA_CATALOGUE) === '1' ||
      this.props.isB2bv2 ||
      !this.props.restrictedRangeActive
    );
  };

  getRedirectPath() {
    const { customerType, myAccountPath, location } = this.props;
    const query = queryString.parse(location.search);
    const entryPoint = lodashGet(query, 'entry_point', '/');
    const componentId = lodashGet(query, 'component_id', null);
    const redirectToMyAccount =
      customerType === IDENTITY_CUSTOMER_TYPES.Business &&
      REDIRECT_TO_MY_ACCOUNT.includes(componentId) &&
      entryPoint === '/';

    return redirectToMyAccount ? myAccountPath : entryPoint;
  }

  render() {
    return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    );
  }
}

LoginRedirect.propTypes = {
  isLoggedIn: PropTypes.bool,
  customerType: PropTypes.string,
  myAccountPath: PropTypes.string,
  location: PropTypes.object,
  restrictedRangeActive: PropTypes.bool
};

LoginRedirect.defaultProps = {
  isLoggedIn: false,
  location: {},
  myAccountPath: ExternalLinksDictionary.user.myaccount
};

const mapStateToProps = ({ user, features }) => ({
  isLoggedIn: lodashGet(user, 'isLoggedIn', false),
  customerType: lodashGet(user, ['profile', 'userDetails', 'customerType']),
  restrictedRangeActive: lodashGet(user, ['profile', 'attributes', 'restrictedRangeActive'], false),
  isB2bv2: features[FEATURES.B2BV2]
});

export default connect(mapStateToProps)(LoginRedirect);
export { LoginRedirect };
